import { createClient } from "@supabase/supabase-js";
import { env } from "../shared/env";

export const supabase = createClient(
  env.VITE_PUBLIC_SUPABASE_URL,
  env.VITE_PUBLIC_SUPABASE_ANON_KEY,
  {
    auth: {
      // Persist + auto-refresh handles "stay signed in" across reloads.
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
